import WarningTab from './WarningTab'
export default WarningTab
